// extracted by mini-css-extract-plugin
export default {"card-categories":"Categories_card-categories__DK0nX","card-categories-title":"Categories_card-categories-title__OketU"};